import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from 'react-intl';
import {Form} from 'formik';
import Button from '../../components/Button';
import FieldSelect from "../../components/FieldSelect";
import ErrorValidation from '../../components/ErrorValidation';
import styles from './styles.module.scss';

const Step1View = ({
                     loadOptions,
                     isValid,
                   }) => {
  const {formatMessage} = useIntl();
  const categoryPlaceholder = formatMessage({
    id: 'step1.form.categories.placeholder',
    defaultMessage: 'Choose category'
  });

  return (
    <Form>
      <div className={styles.innerPadding}>
        <FieldSelect
          fieldId='category'
          label={(
            <FormattedMessage
              id='step1.form.categories.label'
              defaultMessage='Before we start, please choose category'
            />
          )}
          placeholder={categoryPlaceholder}
          loadOptions={loadOptions}
        />
        <div className={styles.notes}>
          <div>
            <FormattedMessage
              id='step1.form.note.1'
              defaultMessage='Signing up to the service takes about 15 minutes, please read carefully all the information and fill everything correctly'
            />
          </div>
          <div>
            <FormattedMessage
              id='common.form.note.unigender'
              defaultMessage='The form is worded in masculine language but is addressed to both men and women'
            />
          </div>
        </div>
        <Button
          label={(
            <FormattedMessage
              id='step1.form.button.submit'
              defaultMessage='Start'
            />
          )}
        />
      </div>
      {!isValid && <ErrorValidation />}
    </Form>
  )
};

Step1View.propTypes = {
  loadOptions: PropTypes.func.isRequired,
  isValid: PropTypes.bool,
};

export default Step1View;
